import React, { useSyncExternalStore } from 'react';
import { Dialog, DialogPanel, DialogTitle, Description } from '@headlessui/react';
import { ArrowRight, Check, Sparkles } from 'lucide-react';
import Brand from './Brand';
import { paymentCelebrations } from '../utils/paymentCelebration';
import '../styles/payment-celebration.css';

export default function PaymentCelebration() {
  const success = useSyncExternalStore(paymentCelebrations.subscribe, paymentCelebrations.getSnapshot);
  if (!success) return null;
  return <Dialog open onClose={paymentCelebrations.dismiss} className="hd-celebration">
    <div className="hd-celebration-backdrop" aria-hidden="true" />
    <div className="hd-celebration-wrap">
      <div className="hd-confetti" aria-hidden="true">{Array.from({ length: 42 }, (_, index) => <i key={index} style={{
        '--x': `${Math.cos(index * 2.4) * (160 + index % 5 * 35)}px`,
        '--y': `${-160 - index % 7 * 26}px`, '--turn': `${index % 2 ? 540 : -540}deg`,
        '--delay': `${index % 6 * 25}ms`, backgroundColor: ['#2563eb', '#de0016', '#071d49', '#f8bf4d', '#93c5fd'][index % 5],
        borderRadius: index % 3 === 0 ? '50%' : '2px',
      }} />)}</div>
      <DialogPanel className="hd-celebration-card">
        <Brand width={154} />
        <div className="hd-celebration-check" aria-hidden="true"><Check size={42} strokeWidth={3} /></div>
        <p className="hd-celebration-eyebrow"><Sparkles size={14} />{success.kind === 'collection' ? 'COLLECTION CONFIRMED' : 'A GREAT START'}</p>
        <DialogTitle>{success.title}</DialogTitle>
        <p className="hd-celebration-subtitle">{success.subtitle}</p>
        <Description>{success.description}</Description>
        <button onClick={paymentCelebrations.dismiss}>{success.action}<ArrowRight size={19} /></button>
      </DialogPanel>
    </div>
  </Dialog>;
}
